import React, { FC, Fragment, useState, useEffect } from 'react';

import { useStatistics } from '../../lib/statistics';
import { UserPage } from '../../components/UserPage';
import { Section } from '../../components/Section';


type Statistics = {
    totalCount: number;
    genres: {
        id: number;
        genre: string;
        parent: string | null;
        count: number;
        children: {
            id: number;
            parent: string | null;
            genre: string;
            count: number;
        }[];
    }[];
};


export const ListPage: FC = () => {
    const [statistics, setStatistics] = useState<Statistics>();
    const { getStatistics } = useStatistics();

    useEffect(() => {
        async function initialize() {
            const resp = await getStatistics();
            setStatistics(resp);
        };
        initialize();
    }, []);

    return (
        <UserPage title="Salon.jp | 全店舗リスト">
            <Section>
                <div className="title">
                    <h1>全店舗リスト</h1>
                    {statistics ? <p className="total-count">計{statistics.totalCount}店舗</p> : null}
                </div>
                {statistics ? <ul className="shops">
                    {statistics.genres.map(({ genre, parent, count, children }) => {
                        const content = <>
                            {parent ? `${parent} ー ` : null}{genre}<span> : {count}（{Math.ceil((count / statistics.totalCount * 100) * 100) / 100}%）</span>
                        </>;
                        return (
                            <li>
                                {count <= 0
                                    ? <a>{content}</a>
                                    : <a href={`/map/list/${genre}`}>{content}</a>
                                }
                                {children && children.length > 0
                                    ? <ul className="childs">{children.map((child) => {
                                        const childContent = <>
                                            {child.parent ? `${child.parent} ー ` : null}{child.genre}<span> : {child.count}（{Math.ceil((child.count / statistics.totalCount * 100) * 100) / 100}%）</span>
                                        </>;
                                        return (
                                            <li>
                                                {child.count <= 0
                                                    ? <a>{childContent}</a>
                                                    : <a href={`/map/list/${child.genre}`}>{childContent}</a>
                                                }
                                            </li>
                                        );
                                    })}</ul>
                                    : null}
                            </li>
                        );
                    }) ?? null}
                </ul> : null}
            </Section>

            <style jsx>{`
                .title {
                    padding-top: 50px;
                    padding-bottom: 26px;
                }
                h1 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0;
                }
                .total-count {
                    margin-top: 0;
                    font-size: 12px;
                }
                .shops {
                    margin: 0;
                    padding: 0;
                }
                .childs {
                    margin: 0;
                    padding: 10px 0 0 20px;
                }
                ul {
                    list-style-type: none;
                }
                li {
                    margin-bottom: 20px;
                }
                a {
                    color: #fe8125;
                    font-size: 16px;
                    text-decoration: none;
                }
                span {
                    font-size: 16px;
                    color: black;
                }
                @media screen and (max-width: 540px) {
                    .title {
                        padding-top: 24px;
                        padding-bottom: 24px;
                    }
                    a {
                        font-size: 14px;
                    }
                    span {
                        font-size: 14px;
                    }
                } 
            `}</style>
        </UserPage>
    );
};
